module.exports = __webpack_public_path__ + "557fc2d9c5dc9278252fb436ddae20c5.svg";